<template>
  <nav class="navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
    <div
      class="
        text-center
        navbar-brand-wrapper
        d-flex
        align-items-center
        justify-content-center
      "
    >
      <a class="navbar-brand brand-logo mr-5" href="/">
        <img src="@/assets/logo_wide.png" class="mr-2" alt="logo" />
      </a>
      <a class="navbar-brand brand-logo-mini" href="/">
        <img src="@/assets/logo.png" alt="logo" />
      </a>
      <button
        class="navbar-toggler navbar-toggler-right d-lg-none align-self-center"
        type="button"
        data-toggle="offcanvas"
      >
        <span class="icon-menu"></span>
      </button>
    </div>
    <div
      class="navbar-menu-wrapper d-flex align-items-center justify-content-end"
    >
      <button
        class="navbar-toggler navbar-toggler align-self-center"
        type="button"
        data-toggle="minimize"
      >
        <span class="icon-menu"></span>
      </button>
      <ul class="navbar-nav navbar-nav-right">
        <!-- Summit Sync Button -->
       <!-- <li class="nav-item mr-2">
          <button
            type="button"
            class="btn btn-sm btn-primary"
            @click="openSyncModal"
            :disabled="isSyncing"
            title="Sync Summit to Temp Database"
          >
            <i class="fas fa-sync" :class="{ 'fa-spin': isSyncing }"></i>
            <span class="d-none d-md-inline ml-1">
              {{ isSyncing ? 'Syncing...' : 'Summit Sync' }}
            </span>
          </button>
        </li>-->

        <li class="nav-item nav-profile dropdown">
          
          <a class="nav-link dropdown-toggle user-avatar"
            href="#"
            data-toggle="dropdown"
            id="profileDropdown"
          >
            <lottie-animation
              style="height: 50px"
              :loop="true"
              :animationData="require('@/assets/lottie/profile.json')"
            />
          </a>
          <div
            class="dropdown-menu dropdown-menu-right navbar-dropdown"
            aria-labelledby="profileDropdown"
          >
            <div class="user-information">
              <span class="user-initial-avatar">{{
                admin.name
                  .split(" ")
                  .map((n) => n[0])
                  .join("")
              }}</span>
              <h4 class="mt-3">{{ admin.name }}</h4>
              <p>{{ admin.email }}</p>
              <a href="#">Edit Profile</a>
            </div>
            <hr style="width: 80%" />
            <a class="dropdown-item" href="/user">
              <i class="icon-head text-primary"></i>
              User Management
            </a>
            <a class="dropdown-item" @click="settings">
              <i class="ti-settings text-primary"></i>
              Settings
            </a>
            <a class="dropdown-item" @click="logout">
              <i class="ti-power-off text-primary"></i>
              Logout
            </a>
          </div>
        </li>
      </ul>
    </div>

    <!-- Summit Sync Modal -->
    <b-modal
      v-model="summitSyncModalShow"
      size="xl"
      hide-footer
      no-close-on-backdrop
    >
      <template #modal-title>
        <strong>Last Synced:</strong> (On-Going Development)
      </template>
      
      <div v-if="!syncResult && !isSyncing">
        <!-- System Notice -->
        <div class="alert alert-info mb-3">
          <i class="fas fa-info-circle mr-2"></i>
          <strong>System Notice:</strong> All maintenance data is synced by default. Enter dates for updated reports.
        </div>

        <!-- Date Input Form -->
        <form class="forms-sample mb-4">
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label for="dateFrom">
                  <i class="fas fa-calendar mr-1"></i>From Date
                </label>
                <input
                  type="date"
                  class="form-control"
                  id="dateFrom"
                  v-model="syncParams.dateFrom"
                />
                <small class="form-text text-muted">
                  Sales Order start date
                </small>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="dateTo">
                  <i class="fas fa-calendar mr-1"></i>To Date
                </label>
                <input
                  type="date"
                  class="form-control"
                  id="dateTo"
                  v-model="syncParams.dateTo"
                />
                <small class="form-text text-muted">
                  Sales Order end date
                </small>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="dateAsOf">
                  <i class="fas fa-calendar mr-1"></i>As Of Date
                </label>
                <input
                  type="date"
                  class="form-control"
                  id="dateAsOf"
                  v-model="syncParams.dateAsOf"
                />
                <small class="form-text text-muted">
                  Stock & Bill Collector
                </small>
              </div>
            </div>
          </div>
        </form>

        <!-- Endpoints to be Synced Card -->
        <!-- <div class="card border-danger mb-3">
          <div class="card-header bg-danger text-white">
            <i class="fas fa-exclamation-triangle mr-2"></i>
            <strong>Endpoints to be Synced</strong>
          </div>
          <div class="card-body">
            <p class="mb-2">The following 8 endpoints will be synchronized:</p>
            <div class="row">
              <div class="col-md-6">
                <ul class="endpoint-list mb-0">
                  <li><i class="fas fa-check-circle text-success mr-2"></i>Principal</li>
                  <li><i class="fas fa-check-circle text-success mr-2"></i>Customer</li>
                  <li><i class="fas fa-check-circle text-success mr-2"></i>State Area Territory</li>
                  <li><i class="fas fa-check-circle text-success mr-2"></i>Sales Agent</li>
                </ul>
              </div>
              <div class="col-md-6">
                <ul class="endpoint-list mb-0">
                  <li><i class="fas fa-check-circle text-success mr-2"></i>Stock On Hand</li>
                  <li><i class="fas fa-check-circle text-success mr-2"></i>Sales Order</li>
                  <li><i class="fas fa-check-circle text-success mr-2"></i>Delivery Monitoring</li>
                  <li><i class="fas fa-check-circle text-success mr-2"></i>Bill Collector</li>
                </ul>
              </div>
            </div>
          </div>
        </div> -->

      </div>

      <!-- Loading State -->
      <div v-if="isSyncing" class="text-center py-5">
        <div class="spinner-border text-primary mb-3" role="status" style="width: 4rem; height: 4rem;">
          <span class="sr-only">Syncing...</span>
        </div>
        <h4 class="mb-2">Syncing Data from Summit API...</h4>
        <p class="text-muted">
          Please wait while we sync data to the temporary database.<br>
          This process may take several minutes.
        </p>
        <div class="progress mt-4" style="height: 25px;">
          <div 
            class="progress-bar progress-bar-striped progress-bar-animated bg-primary" 
            role="progressbar" 
            style="width: 100%"
          >
            Processing...
          </div>
        </div>
      </div>

      <!-- Result Display -->
      <div v-if="syncResult && !isSyncing">
        <div
          :class="[
            'alert',
            syncResult.success ? 'alert-success' : 'alert-danger',
          ]"
        >
          <h5 class="mb-0">
            <i
              :class="[
                'fas mr-2',
                syncResult.success ? 'fa-check-circle' : 'fa-times-circle',
              ]"
            ></i>
            {{ syncResult.message }}
          </h5>
        </div>

        <!-- Performance Summary -->
        <div class="card mb-3" v-if="syncResult.performance">
          <div class="card-header bg-info text-white">
            <strong><i class="fas fa-chart-line mr-2"></i>Performance Summary</strong>
          </div>
          <div class="card-body">
            <div class="row text-center">
              <div class="col-md-3">
                <div class="mb-2">
                  <i class="fas fa-clock text-primary" style="font-size: 2rem;"></i>
                </div>
                <h4 class="mb-0">{{ syncResult.performance.totalDuration }}</h4>
                <small class="text-muted">Total Duration</small>
              </div>
              <div class="col-md-3">
                <div class="mb-2">
                  <i class="fas fa-tachometer-alt text-success" style="font-size: 2rem;"></i>
                </div>
                <h4 class="mb-0">{{ syncResult.performance.averagePerEndpoint }}</h4>
                <small class="text-muted">Avg Per Endpoint</small>
              </div>
              <div class="col-md-3">
                <div class="mb-2">
                  <i class="fas fa-server text-info" style="font-size: 2rem;"></i>
                </div>
                <h4 class="mb-0">{{ syncResult.summary.successful }}</h4>
                <small class="text-muted">Successful</small>
              </div>
              <div class="col-md-3">
                <div class="mb-2">
                  <i class="fas fa-database text-warning" style="font-size: 2rem;"></i>
                </div>
                <h4 class="mb-0">
                  {{ (syncResult.summary.totalRecordsSyncedToTemp || 0).toLocaleString() }}
                </h4>
                <small class="text-muted">Total Records</small>
              </div>
            </div>
          </div>
        </div>

        <!-- Detailed Results Table -->
        <div class="card" v-if="syncResult.detailedResults && syncResult.detailedResults.length">
          <div class="card-header bg-dark text-white">
            <strong><i class="fas fa-list mr-2"></i>Endpoint Details</strong>
          </div>
          <div class="card-body p-0">
            <div class="table-responsive">
              <table class="table table-hover mb-0">
                <thead class="thead-light">
                  <tr>
                    <th style="width: 5%;">#</th>
                    <th style="width: 25%;">Endpoint</th>
                    <th style="width: 10%;" class="text-center">Status</th>
                    <th style="width: 10%;" class="text-center">Duration</th>
                    <th style="width: 15%;" class="text-right">Records</th>
                    <th style="width: 35%;">Message</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(result, index) in syncResult.detailedResults"
                    :key="index"
                    :class="{ 'table-danger': !result.success }"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>
                      <strong>{{ result.endpoint }}</strong>
                    </td>
                    <td class="text-center">
                      <span
                        :class="[
                          'badge badge-pill',
                          result.success
                            ? 'badge-success'
                            : 'badge-danger',
                        ]"
                      >
                        {{ result.success ? "✓ Success" : "✗ Failed" }}
                      </span>
                    </td>
                    <td class="text-center">
                      <span class="badge badge-secondary">
                        {{ result.duration }}
                      </span>
                    </td>
                    <td class="text-right">
                      <strong>{{ (result.totalRecords || 0).toLocaleString() }}</strong>
                    </td>
                    <td>
                      <small class="text-muted">{{ result.message || 'N/A' }}</small>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- Error Details -->
        <div v-if="!syncResult.success && syncResult.error" class="alert alert-danger mt-3">
          <h6><i class="fas fa-exclamation-triangle mr-2"></i>Error Details:</h6>
          <p class="mb-0"><strong>{{ syncResult.error }}</strong></p>
          <p v-if="syncResult.innerException" class="mb-0 mt-2">
            <small>{{ syncResult.innerException }}</small>
          </p>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col">
          <button
            type="button"
            class="btn btn-outline-light"
            @click="closeSyncModal"
            :disabled="isSyncing"
          >
            {{ syncResult ? "Close" : "Cancel" }}
          </button>
          <button
            v-if="!syncResult"
            type="button"
            class="btn btn-primary ml-2"
            @click="confirmSync"
            :disabled="isSyncing"
          >
            <i class="fas fa-sync mr-1"></i>
            Start Sync
          </button>
          <button
            v-if="syncResult"
            type="button"
            class="btn btn-primary ml-2"
            @click="resetSync"
          >
            <i class="fas fa-redo mr-1"></i>
            Sync Again
          </button>
        </div>
      </div>
    </b-modal>

    <!-- Confirmation Modal -->
    <b-modal
      v-model="showConfirmModal"
      title="Confirm Sync"
      size="md"
      header-bg-variant="danger"
      header-text-variant="white"
      hide-footer
      no-close-on-backdrop
    >
      <div class="text-center py-3">
        <i class="fas fa-exclamation-triangle text-danger" style="font-size: 3rem;"></i>
        <h5 class="mt-3 mb-3">Are you Sure you want to Proceed?</h5>
        <div class="alert alert-danger text-left">
          <small>
            <strong>Note:</strong> This will sync 8 endpoints: Principal, Customer, State Area Territory, Sales Agent, Stock On Hand, Sales Order, Delivery Monitoring, and Bill Collector.
          </small>
        </div>
      </div>
      <div class="text-center mt-3">
        <button
          type="button"
          class="btn btn-outline-secondary"
          @click="showConfirmModal = false"
        >
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-danger ml-2"
          @click="startSync"
        >
          Yes
        </button>
      </div>
    </b-modal>
  </nav>
</template>

<script>
import { mapState } from "vuex";
import LottieAnimation from "lottie-web-vue";

export default {
  components: {
    LottieAnimation,
  },
  data() {
    return {
      summitSyncModalShow: false,
      showConfirmModal: false,
    };
  },
  computed: {
    ...mapState({
      admin: (state) => state.admin.info,
      syncResult: (state) => state.summitSyncController.syncResult,
      isSyncing: (state) => state.summitSyncController.isSyncing,
      syncParams: (state) => state.summitSyncController.syncParams,
    }),
  },
  methods: {
    logout: async function () {
      await this.$store.dispatch("deleteToken");
      window.location.href = "/";
    },
    settings: function () {
      this.$toast.open({
        message: "This feature is not yet implemented.",
        type: "info",
      });
    },
    openSyncModal() {
      this.$store.dispatch("summitSyncController/ResetSyncResult");
      this.$store.dispatch("summitSyncController/ResetSyncParams");
      this.summitSyncModalShow = true;
    },
    closeSyncModal() {
      if (!this.isSyncing) {
        this.summitSyncModalShow = false;
      }
    },
    resetSync() {
      this.$store.dispatch("summitSyncController/ResetSyncResult");
      this.$store.dispatch("summitSyncController/ResetSyncParams");
    },
    confirmSync() {
      this.showConfirmModal = true;
    },
    async startSync() {
      this.showConfirmModal = false;
      
      // Set the sync params before calling the action
      await this.$store.dispatch("summitSyncController/SetSyncParams", this.syncParams);

      var result = await this.$store
        .dispatch("summitSyncController/SyncSummitToTemp")
        .catch(async (error) => {
          const errorMessage =
            error?.data?.message ||
            error?.data?.error ||
            error?.data ||
            "Unknown error occurred";

          this.$toast.open({
            message: errorMessage,
            type: "error",
            duration: 5000,
          });
        });

      if (result) {
        this.$toast.open({
          message: result.success
            ? `✓ Summit sync completed! ${result.summary?.totalRecordsSyncedToTemp?.toLocaleString() || 0} records synced.`
            : `⚠ Summit sync completed with ${result.summary?.failed || 0} error(s)`,
          type: result.success ? "success" : "warning",
          duration: 5000,
        });
      }
    },
  },
};
</script>

<style scoped>
.fa-spin {
  animation: fa-spin 1s infinite linear;
}

@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.table-hover tbody tr:hover {
  background-color: rgba(0, 123, 255, 0.05);
}

.badge-pill {
  padding: 0.35em 0.65em;
  font-size: 0.85rem;
}

.card-header {
  font-weight: 600;
}

.progress {
  border-radius: 1rem;
}

.endpoint-list {
  list-style: none;
  padding-left: 0;
}

.endpoint-list li {
  padding: 0.5rem 0;
  border-bottom: 1px solid #f0f0f0;
}

.endpoint-list li:last-child {
  border-bottom: none;
}

.border-danger {
  border: 2px solid #dc3545 !important;
}
</style>